import { ReloadOutlined, SyncOutlined } from "@ant-design/icons";
import { Button, DatePicker, Select, Tooltip } from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

const { RangePicker } = DatePicker;

const DashboardFilterBar = ({
  dateRange,
  warehouse,
  warehouseOptions,
  lastUpdated,
  refreshing,
  onRefresh,
  onDateChange,
  onWarehouseChange,
  onClearFilter,
}) => {
  const { t } = useTranslation("dashboard");
  const rangeValue = dateRange.length === 2 ? [dayjs(dateRange[0]), dayjs(dateRange[1])] : null;

  return (
    <div className="es-filter-bar flex justify-end">
      <div className="es-header-actions">
        <RangePicker
          value={rangeValue}
          onChange={(dates) => {
            if (!dates) {
              onDateChange([]);
              return;
            }
            onDateChange([dates[0].format("YYYY-MM-DD"), dates[1].format("YYYY-MM-DD")]);
          }}
          format="DD/MM/YYYY"
          showNow
          classNames={{ popup: { root: "es-range-popup" } }}
        />
        <Select value={warehouse} onChange={onWarehouseChange} style={{ minWidth: 180 }} options={warehouseOptions} />
        <Button icon={<ReloadOutlined />} onClick={onClearFilter}>
          {t("Filter.Clear")}
        </Button>
        <span className="es-last-updated">
          <Tooltip title={refreshing ? t("Filter.Refreshing") : t("Filter.Refresh_Data")}>
            <Button
              type="text"
              size="small"
              className="es-refresh-btn"
              aria-label={t("Filter.Refresh_Data")}
              icon={<SyncOutlined spin={refreshing} />}
              onClick={onRefresh}
            />
          </Tooltip>
          {t("Filter.Last_Updated")} {lastUpdated ? dayjs(lastUpdated).format("DD/MM/YYYY HH:mm:ss") : "-"}
        </span>
      </div>
    </div>
  );
};

export default DashboardFilterBar;
